import { t } from '../../../../common/components/T';
import { generateCompStylers, getStylePropsFunc } from '../../../../common/utils/styles';
import DropdownElement from '../../../../hybrid/library/DropdownElement';
import ExcelButton from '../../../excelButton/ExcelButton';
import FormInput from '../../../form/components/form-input/FormInput/FormInput';

const OrderHead = ({
    setShowModal,
    transl,
    compStyles,
    screenWidth,
    textsData,
    pageSettings,
    inputGlobFilter,
    globalSearch,
    selectPageConfig,
    exportData,
    dataFiltersToUrl
}) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);
    const { stylers, classes } = generateCompStylers(compStyles);
    return (
        <>
            <div {...getStyleProps('headerTable')}>
                <div {...getStyleProps('dFlex', 'justifyContentBetween', 'w100')}>
                    <div {...getStyleProps('orderHeadBlockFilter')}>
                        <div {...getStyleProps('summaryBlockFilterFlexStart', 'dFlex', 'alignItemsCenter')}>
                            <p {...getStyleProps('orderSearthPlaceholder')}>
                                {textsData.globalSearthPlaceholderLabel || textsData.globalSearthPlaceholder}
                            </p>
                            {!screenWidth && (
                                <div {...getStyleProps('orderBlockFilterStyles')}>
                                    <FormInput
                                        value={inputGlobFilter?.[0]}
                                        compStyle={{
                                            icon: { fill: 'var(--greyExtraDarkColor)' },
                                            wrapper: {
                                                ...stylers.searthTableInput,
                                                className: classes.searthTableInput
                                            },
                                            global: {
                                                icon: { width: '18px' }
                                            }
                                        }}
                                        handlers={{
                                            onChange: (val) => {
                                                globalSearch(val);
                                            }
                                        }}
                                        search={{
                                            type: 'onInput',
                                            icon: 'search-thin'
                                        }}
                                        placeholder={
                                            textsData.globalSearthPlaceholder ||
                                            t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                        }
                                        buttons={
                                            !pageSettings?.hideGlobalSearch
                                                ? {
                                                      global: {
                                                          icon: 'sliders',
                                                          handler: () => setShowModal(true)
                                                      }
                                                  }
                                                : {}
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div {...getStyleProps('dFlex', 'alignItemsCenter', 'orderBlockFilterWidthRight')}>
                        <div {...getStyleProps('orderBlockFilterRight', 'hideMobile')}>
                            <div {...getStyleProps('summaryBlockFilterFlex')}>
                                <div {...getStyleProps('selectPageWrap')}>
                                    <p {...getStyleProps('selectPageText')}>
                                        {(textsData.itemOnPage ||
                                            (screenWidth
                                                ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                                : t(
                                                      'gridHeader-sselectPageText',
                                                      'Записей на странице',
                                                      'widget',
                                                      transl,
                                                      'gridFilter'
                                                  ))) + ':'}
                                    </p>
                                    <DropdownElement componentConfig={selectPageConfig} />
                                </div>
                            </div>
                        </div>
                        {exportData && <ExcelButton filter={dataFiltersToUrl} exportData={exportData} />}
                    </div>
                </div>
                <div {...getStyleProps('showMobile')}>
                    <div {...getStyleProps('orderBlockFilterRight')}>
                        <div {...getStyleProps('summaryBlockFilterFlex')}>
                            <div {...getStyleProps('selectPageWrap')}>
                                <p {...getStyleProps('selectPageText')}>
                                    {(textsData.itemOnPage ||
                                        (screenWidth
                                            ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                            : t(
                                                  'gridHeader-sselectPageText',
                                                  'Записей на странице',
                                                  'widget',
                                                  transl,
                                                  'gridFilter'
                                              ))) + ':'}
                                </p>
                                <DropdownElement componentConfig={selectPageConfig} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default OrderHead;
